export const QR_HOME_PATH = "/";
export const QR_DASHBOARD_MAIN_PATH = "/dashboard";
export const QR_DASHBOARD_AUTH_PATH = "/auth";
export const QR_DASHBOARD_AUTH_LOGOUT_PATH = "/logout";
export const QR_DETAILS_PATH = "/qr";
export const QR_ADMIN_CHANGE_PASSWORD_PATH = "/change-password";
